<template>
    <div class="zebraAccordion">
        <div class="zebraRow" v-for="(day, index) in dateOfWeek" :key="index">
            <div class="accordion" role="tablist">
                <div class="zebraItem" v-b-toggle="`therapy-accordion-${uid}-${index}`">
                    <b-row class="d-flex align-items-center">
                        <b-col md="12">
                            <div class="float-left">
                                <span
                                    @click="remove(value, day)"
                                    @click.stop
                                    class="rounded-circle tableActionBTN tableBTNtext tableActionBTN-danger ikon med-bin"
                                ></span>
                                <span>{{ meetingDay(day) }}</span>
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <b-card no-body>
                    <b-collapse
                        :id="`therapy-accordion-${uid}-${index}`"
                        accordion="my-therapy-accordion"
                        role="tabpanel"
                    >
                        <b-card-body
                            class="accordionContent pt-3"
                            style="padding: 10px !important;"
                        >
                            <div class="card">
                                <b-row>
                                    <b-col
                                        md="6"
                                        sm="12"
                                        lg="6"
                                        v-for="(program, pIndex) in programsDays(day)"
                                        :key="`program-${uid}-${index}-${pIndex}`"
                                    >
                                        <div class="float-left">
                                            <span
                                                @click="editDetail(program)"
                                                @click.stop
                                                class="rounded-circle tableActionBTN tableBTNtext tableActionBTN-danger ikon med-pen"
                                            ></span>
                                            <br />
                                            <span
                                                @click="removeDetail(program)"
                                                @click.stop
                                                class="rounded-circle tableActionBTN tableBTNtext tableActionBTN-danger ikon med-bin mt-1"
                                                v-if="removeDetailButtonVisible(day)"
                                            ></span>
                                        </div>

                                        <div class="float-left col-md-2">
                                            <small> {{ $t('Shared.Time') }} </small><br />
                                            <span v-if="program.meetingTime">
                                                {{ formattedTime(program.meetingTime) }}
                                            </span>
                                            <span v-else>{{ $t('Shared.Notdefined') }}</span>
                                        </div>

                                        <div class="float-left col-md-2">
                                            <small> {{ $t('Shared.TimeTo') }} </small><br />
                                            <span v-if="program.timeTo">
                                                {{ formattedTime(program.timeTo) }}
                                            </span>
                                            <span v-else>{{ $t('Shared.Notdefined') }}</span>
                                        </div>

                                        <div class="float-left col-md-3">
                                            <small> {{ $t('Shared.Location') }} </small><br />
                                            <span v-if="program.location">
                                                {{ program.location }}
                                            </span>
                                            <span v-else>{{ $t('Shared.Notdefined') }}</span>
                                        </div>

                                        <div class="float-left col-md-3">
                                            <small> {{ $tc('Shared.Therapist', 1) }} </small><br />
                                            <span v-if="program.therapistcode">
                                                {{ program.therapistcode }}
                                            </span>
                                            <span v-else>{{ $t('Shared.Notdefined') }}</span>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import Utils from '@/common/utils';

export default {
    name: 'therapyDetails',
    props: {
        value: {
            Type: Array,
            required: true
        },
        remove: {
            type: Function,
            required: true
        },
        removeDetail: {
            type: Function,
            required: true
        },
        editDetail: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            uid: Utils.generateRecID()
        };
    },
    computed: {
        dateOfWeek() {
            return [...new Set(this.value.map(x => +x.meetingDay))].sort((x, y) =>
                x < y ? -1 : x > y ? 1 : 0
            );
        }
    },
    methods: {
        formattedTime(time) {
            return Utils.formatterTimeToString(time);
        },
        programsDays(day) {
            return this.value.filter(x => x.meetingDay === day);
        },
        meetingDay(day) {
            switch (day) {
                case 1:
                    return this.$t('Layout.dDay.Sunday');
                case 2:
                    return this.$t('Layout.dDay.Monday');
                case 3:
                    return this.$t('Layout.dDay.Tuesday');
                case 4:
                    return this.$t('Layout.dDay.Wednesday');
                case 5:
                    return this.$t('Layout.dDay.Thursday');
                case 6:
                    return this.$t('Layout.dDay.Friday');
                case 7:
                    return this.$t('Layout.dDay.Saturday');
            }

            return '';
        },
        removeDetailButtonVisible(day) {
            return this.programsDays(day).length > 1;
        },
        addTherapy() {}
    }
};
</script>

<style scoped>
.zebraAccordion {
    margin: 0 0;
}
.resetFontSize small {
    font-size: 0.95em;
}
.zebraAccordion .zebraRow .zebraItem {
    border-radius: 4px 4px 0 0;
    padding: 5px;
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
}

.zebraAccordion .zebraRow:nth-child(odd) .zebraItem {
    background-color: #d4f7ff;
}
.zebraAccordion .zebraRow:nth-child(even) .zebraItem {
    background-color: #ecfcff;
}

.zebraAccordion .zebraRow .accordion .zebraItem.not-collapsed {
    background-color: #19bee1;
    color: #fff;
}
.zebraAccordion .zebraRow .accordion .zebraItem:hover {
    background-color: #64d6f0;
    color: #fff;
}
.zebraAccordion .zebraRow .zebraItem small {
    font-size: 0.7em;
}
.accordionContent {
    border-top: 0;
    background: linear-gradient(173deg, #d9f4fb, #fff 30%);
    padding-top: 3em;
}
</style>
